module.exports = __webpack_public_path__ + "static/img/HichamItani.9375b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/whoweare/HichamItani.png
// module id = AxTM
// module chunks = 1